import React from "react";
import Header from "../layouts/header";
import Sidebar from "../layouts/sidebar";
import Layout from "../layouts/layout";
import PageHeading from "../layouts/pageHeading";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link as MuiLink, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { cssProperties } from "../utils/commonCssProperties";
import Cookies from "js-cookie";
import Index from "../components/CapCourseDocumentMaster";

export default function CapCourseDocumentMaster() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const naviagte = useNavigate();

  const handleClick = () => {
    if (page === "addcapcoursedocument" || page === "updatecapcoursedocument") {
      naviagte(`/${Cookies.get("mhet_mst_project")}/cap-course-document-master`);
    }
  };

  const breadcrumbs = [
    <MuiLink
      underline="hover"
      key="1"
      component={NavLink}
      to={`/${Cookies.get("mhet_mst_project")}/home`}
      sx={{
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Dashboard
    </MuiLink>,
    <Typography
      key="3"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: page === "cap-course-document-master"  ? "bold" : 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
        ":hover":{
          textDecoration: page === "cap-course-document-master" ? "none" : "underline",
          cursor : page === "cap-course-document-master" ? "none" : "pointer"
        }
      }}
      onClick={page === "cap-course-document-master" ? undefined : handleClick}
    >
     CAP Course Document Master {page === "cap-course-document-master" && <MdKeyboardArrowDown size={16} /> }
    </Typography>,
  ];

  if (page === "addcapcoursedocument") {
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Add Cap Course Document<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }else if (page === "updatecapcoursedocument"){
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Update Cap Course Document<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs}/>
      <Sidebar />
      <Layout>
        <PageHeading
          title={
            page === "cap-course-document-master"
              ? "CAP Course Document Master"
              : page === "addcapcoursedocument"
              ? "Add CAP Course Document"
              : page === "updatecapcoursedocument"
              ? "UpdateCAP Course Document"
              : null
          }
        />
        
        <Index />
      </Layout>
    </>
  );
}
